import EditVariationModal from './EditVariationModal';

export default EditVariationModal;
